import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import SourceflowForm from "@sourceflow-uk/sourceflowform";
import useLocale from "@/hooks/useLocale";

export default function SubmitForm({
  formId = "cf57fd4d-c47a-4c9c-9c5b-fec7e1ae8b22",
}) {
  const locale = useLocale();

  return (
    <div className="pb-20 container">
      <div className="bg-jacarta px-5 md:pr-[72px] md:pl-[50px] py-[40px] sm:py-[65px] flex flex-col justify-between relative z-50 lg:flex-row">
        <h3 className="mb-10 text-3xl sm:text-[40px] xl:text-[50px]/[60px] text-white lg:mb-0 lg:max-w-[347px] 3xl:max-w-[50%]">
          <CustomSourceFlowText
            title="Ready for next steps? We’re looking forward to hearing from you."
            path="dynamic1.recruitment.header1"
            locale={locale}
          />
        </h3>
        <div>
          <h3 className="text-white text-lg sm:text-xl md:text-2xl lg:text-[30px]/[40px]">
            <CustomSourceFlowText
              title="Or, submit a query below:"
              path="dynamic1.recruitment.header2"
              locale={locale}
            />
          </h3>
          <div className="contact_form">
            <SourceflowForm formId={formId} />
          </div>
        </div>
      </div>
    </div>
  );
}
